import React from 'react';
import { AppBar, Avatar, Toolbar, Typography } from '@material-ui/core';
import { useUser } from 'hooks';
import { Create, DeviceHub } from '@material-ui/icons';
import clsx from 'clsx';

import { Sidebar } from 'ui';
import { BatteryIcon, DashboardIcon, InstallerIcon, ManufacturerIcon, OwnerIcon, VerifierIcon } from 'ui/icons';
import { AppRoute } from 'routing/AppRoute.enum';
import { Route } from 'ui/sidebar/Sidebar.types';
import { UserRole } from 'context/user/userContext/UserContext.types';
import { truncateString } from 'helpers';

import { useStyles } from './DesktopPage.styles';
import { DesktopPageProps } from './DesktopPage.types';

const mapRoleToIcon = {
  [UserRole.Manufacturer]: <ManufacturerIcon color="inherit" />,
  [UserRole.GoverningBody]: <ManufacturerIcon color="inherit" />,
  [UserRole.Owner]: <OwnerIcon color="inherit" />,
  [UserRole.Installer]: <InstallerIcon color="inherit" />,
  [UserRole.Verifier]: <VerifierIcon color="inherit" />,
};

export const DesktopPage = ({ children, onMenuClick }: DesktopPageProps) => {
  const { user } = useUser();
  const { appBar, toolbar, avatar, userName, sideBar, container, roleIcon, roleAvatar, link } = useStyles({
    role: user?.role,
  });

  const sidebarItems: Route[] = [
    {
      icon: DashboardIcon,
      text: 'navigation.dashboard',
      route: AppRoute.dashboard,
    },
    {
      icon: BatteryIcon,
      text: 'navigation.batteries',
      route: AppRoute.desktopDashboardGrid,
    },
    {
      icon: DeviceHub,
      text: 'navigation.explorer',
      onClick: () => {
        window.open(process.env.REACT_APP_EXPLORER_URL as string, '_blank');
      },
    },
    {
      icon: Create,
      text: 'navigation.mint_tokens',
      route: AppRoute.desktopMintTokens,
    },
  ];

  const redirectToExplorer = () => {
    window.open(`${process.env.REACT_APP_EXPLORER_URL as string}address/${user?.address ?? ''}`, '_blank');
  };

  return (
    <>
      <AppBar elevation={0} className={appBar}>
        <Toolbar disableGutters className={toolbar}>
          <Typography className={clsx(userName, link)} onClick={redirectToExplorer}>
            {truncateString({ maxLength: 12, string: user?.address ?? '' })}
          </Typography>
          <Typography className={userName}>{`${user?.firstName} ${user?.lastName}`}</Typography>
          <div className={roleAvatar}>
            <Avatar onClick={onMenuClick} src={user?.avatar} className={avatar} alt="user" />
            <div className={roleIcon}>{mapRoleToIcon[user?.role || UserRole.Owner]}</div>
          </div>
        </Toolbar>
      </AppBar>
      <Toolbar disableGutters className={toolbar} />
      <Sidebar wrapperClassName={sideBar} items={sidebarItems} />
      <div className={container}>{children}</div>
    </>
  );
};
